import { Value } from 'baseui/select';
import { FlightCheckInStatusEnum } from 'common/constants/enum';
import Separator from 'components/common/separator';
import Select from 'components/elements/master/select-input';
import Text from 'components/elements/text';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { FlightScheduleFormType } from './flight-schedule-form-type';

const name = 'flightSchedules' as const;
export default function FlightScheduleStatusSelect() {
  const [selectValue, setSelectValue] = React.useState<Value>([
    {
      id: FlightCheckInStatusEnum.NotAvailable,
      label: 'Not Available',
    },
  ]);
  const { control, setValue } = useFormContext<FlightScheduleFormType>();

  const flightSchedules = useWatch({
    name,
    control,
  });

  const hasChecked =
    flightSchedules.length !== 0 &&
    flightSchedules.some((schedule) => schedule.isCheck);

  return (
    <div
      style={{
        maxWidth: 160,
      }}
    >
      <Text variant="LabelSmall">Update Selected Status</Text>
      <Separator gap={6} />
      <Select
        disabled={!hasChecked}
        options={[
          {
            id: FlightCheckInStatusEnum.NotAvailable,
            label: 'Not Available',
          },
          {
            id: FlightCheckInStatusEnum.NotCheckedIn,
            label: 'Not Check In',
          },
          {
            id: FlightCheckInStatusEnum.CheckedIn,
            label: 'Check In',
          },
          {
            id: FlightCheckInStatusEnum.SeatOk,
            label: 'Seat Ok',
          },
        ]}
        clearable={false}
        value={selectValue}
        onChange={(params) => {
          const details = flightSchedules.map((schedule) => {
            return schedule.isCheck
              ? {
                  ...schedule,
                  checkInStatus: params?.option
                    ?.id as FlightCheckInStatusEnum | null,
                }
              : schedule;
          });
          setValue(name, details);
          setSelectValue(params.value);
        }}
      />
    </div>
  );
}
